/*
 * @Author: your name
 * @Date: 2020-08-21 18:15:16
 * @LastEditTime: 2020-10-10 16:59:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \eunke-st-www\src\utils\mapUtil.js
 */
//const ak = 'UsvGHHBzXcidVsLACCnbhgpOG6yUqDXK'

import axios from 'axios'
const http = axios.create({
    timeout: 10000
})

const ak = 'UsvGHHBzXcidVsLACCnbhgpOG6yUqDXK'
// https://apis.map.qq.com/ws/district/v1/list
/**
 * 地理编码
 * 地址转经纬度
 */
export function geocoding(vm, address) {
    return vm.$jsonp(
        //调用百度地图，获取地理位置的经纬度
        `http://api.map.baidu.com/geocoding/v3/?address=${address}&output=json&ak=${ak}`
    )
}


/**
 * 获取附近相关的点
 */
export function geoplace(vm, address, region) {
    console.log(address + ':' + region)
    return vm.$jsonp(
        //调用百度地图，获取地理位置的经纬度
        `http://api.map.baidu.com/place/v2/search?query=${address}&output=json&ak=${ak}&region=${region}`
    )
}


let key = 'SXUBZ-STPRX-VI44V-7WWUN-OIONF-2FFQ6'
export function geoplace2(vm, address, region) {
    console.log(address + ':' + region)
    let opts = {
        keyword: encodeURI(address),
        boundary: region ? `region(${encodeURI(region)}, 0)` : '', // 0 为限定范围搜搜索，1为开放范围搜素偶
        page_size: 10, // 搜索结果分页最大条数
        page_index: 1, // 指定分页
        key,
        output: 'jsonp'
    }
    return vm.$jsonp(`http://apis.map.qq.com/ws/place/v1/search`, opts)
}

